__turbopack_context__.v({
  "line": "SummarySkeleton-module__DLWZuq__line",
  "shimmer": "SummarySkeleton-module__DLWZuq__shimmer",
});
